function n(x: number): number {
  const a1 = 0.31938153,
    a2 = -0.356563782,
    a3 = 1.781477937,
    a4 = -1.821255978,
    a5 = 1.330274429;
  if (x < 0.0) {
    return 1 - n(-x);
  } else {
    const k = 1.0 / (1 + 0.2316419 * x);
    return 1 - (Math.exp((-x * x) / 2) / Math.sqrt(2 * Math.PI)) * k * (a1 + k * (a2 + k * (a3 + k * (a4 + k * a5))));
  }
}

// https://www.investopedia.com/terms/b/blackscholes.asp
export function blackScholes(
  stockPrice: number,
  strikePrice: number,
  rate: number,
  volatility: number,
  expYears: number,
): number {
  const d1 =
    (Math.log(stockPrice / strikePrice) + (rate + ((volatility * volatility) / 2) * expYears)) /
    (volatility * Math.sqrt(expYears));
  const d2 = d1 - volatility * Math.sqrt(expYears);
  return stockPrice * n(d1) - strikePrice * Math.exp(-rate * expYears) * n(d2);
  // put options
  //result = (data.strikePrice * Math.exp(-data.riskFreeRate * data.expirationTimeInYears) * n(-d2) - data.stockPrice * n(-d1));
}
